import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './invoiceData.css';
import _isEmpty from 'lodash/isEmpty';
import { getInvoiceData, getMemberVendorNames,getTerminatedVPNamesForMember,
    getMemberInvoicesBranchData,tabTracking } from '../../../actions';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
// import { Dropdown } from 'react-bootstrap';
import ReactExport from "react-export-excel";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { PriceFormatter,PriceFormatter2,dynamicDateFilters,jsonToParam1, monthName,jsonToParam,paramsToJSON } from '../../../helper';
import { matLoader } from '../../../components/Loader';
import axios from "axios";
import { ROOT_URL } from '../../../actions';

let token = localStorage.getItem('imark-token');
console.debug("Setting Authentication Token", token);

axios.defaults.headers.common['Authorization'] = "Bearer " + token;

class InvoiceData extends React.Component {
    state = {
        isLoading: true,
        params: {
            fromDate: "",
            toDate: "",
            memberId: this.props.memberIdForCorporate,
            buyingGroupId: this.props.buyingGroupId,
            dropDown: [],
            poNumber:"",
            invoiceNo:"",
            vendorId:"",
            start:"",
            length:""
        },
    }

    componentWillMount() {
        
        let paramsValues = this.state.params;
        let paramsfinal = dynamicDateFilters(paramsValues);
        let params = jsonToParam(paramsfinal);

        console.log(params);
        this.setState({ params: params });
        
    }

    componentDidMount() {
        
        Promise.all([
            this.props.getInvoiceDataAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=5"),
            this.props.getTerminatedVPNamesForMemberAPI(this.state.params),
            this.props.getMemberInvoicesBranchDataAPI(this.state.params)
        ]).then(data=>{
            this.setState({
                isLoading: false
            })
        }).catch(err=>{
            this.setState({
                isLoading: false
            })
        }) 
       
    }
    handleSearch = (e) => {

        let params = this.state.params;
        params = paramsToJSON(params);
        params.poNumber=  params.poNumber;
        params.invoiceNo= params.invoiceNo;
        params.fromDate= params.fromDate;
        params.toDate= params.toDate;
        params.memberId= this.props.memberIdForCorporate;
        params = jsonToParam(params);
        this.setState({
            params: params
          });
          this.props.getInvoiceDataAPI(params);
          
    }
    getInvoiceDefaultData = (e) => {
        
        let params = this.state.params;
        params = paramsToJSON(params);
        this.refs.fromDate.value = '';
        this.refs.toDate.value = '';
        this.refs.invoiceNo.value = '';
        this.refs.poNumber.value = '';
        this.refs.vendorId.value = '';
        params.fromDate= "";
        params.toDate= "";
        params.memberId=this.props.memberIdForCorporate;
        params.invoiceNo= "";
        params.poNumber= "";
        params.vendorId="";
        params = jsonToParam(params);
        this.setState({ params: params,poNumber :'',invoiceNo: "",fromDate:"",toDate:""})
        this.props.getInvoiceDataAPI(params);
      
    }

    handleStartDataChange = (e) => {
        //;
        let params = this.state.params;
        params = paramsToJSON(params);
        params.dropDown = [...params.dropDown]
        params.fromDate= e.target.value;
        params.toDate= params.toDate;
        params.memberId=this.props.memberIdForCorporate;
        params.invoiceNo= params.invoiceNo
        params.poNumber= params.poNumber;
        params = jsonToParam(params);
        this.setState({
            params: params
          });
        //this.props.getInvoiceDataAPI(params);
        
    }

    handleEndDataChange = (e) => {
        let params = this.state.params;
        params = paramsToJSON(params);
        params.dropDown = [...params.dropDown]
        params.fromDate= params.fromDate;
        params.toDate= e.target.value;
        params.memberId=this.props.memberIdForCorporate;
        params.invoiceNo= params.invoiceNo
        params.poNumber= params.poNumber;
        params = jsonToParam(params);
        this.setState({
            params: params
          });
       // this.props.getInvoiceDataAPI(params);
    }
    handlePurchaseOrderChange = (e) => {
        let params = this.state.params;
        params = paramsToJSON(params);
        params.dropDown = [...params.dropDown]
        params.poNumber= e.target.value
        params.invoiceNo= params.invoiceNo
        params.fromDate= params.fromDate;
        params.toDate= params.toDate;
        params.memberId= this.props.memberIdForCorporate;
        params = jsonToParam(params);
        this.setState({
            params: params
          });
        //this.props.getInvoiceDataAPI(params);
    }
    handleInvoiceChange = (e) => {
        let params = this.state.params;
        params = paramsToJSON(params);
        params.dropDown = [...params.dropDown]
        params.invoiceNo= e.target.value
        params.poNumber= params.poNumber;
        params.fromDate= params.fromDate;
        params.toDate= params.toDate;
        params.memberId=this.props.memberIdForCorporate;
        params = jsonToParam(params);
        this.setState({
            params: params
          });
        //this.props.getInvoiceDataAPI(params);
    }

    showDate = (row) =>{
        let date = new Date(row);
        return (
        <div>{date.toLocaleDateString()}</div>
        )
      }
      handleClick = (e, value) => {
        let params = this.state.params;
        params = paramsToJSON(params);
        let arr = [];
        let valstr = [value.value];
        if (valstr != "" && valstr != "undefined") {
            let valueee = valstr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
            })
            params.vendorId = arr
        }
        else {
            params.vendorId = "";
        }
        params = jsonToParam(params);
            this.setState({
                params: params, flag: true
            });
    }
    handleClickBranch= (e, value) => {
        let params = this.state.params;
        params = paramsToJSON(params);
        let arr = [];
        let valstr = [value.value];
        if (valstr != "" && valstr != "undefined") {
            let valueee = valstr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
            })
            params.memberId = arr
        }
        else {
            params.memberId = "";
        }
        params = jsonToParam(params);
            this.setState({
                params: params, flag: true
            });
    }

    FileDownload1 =()=> {
        let params = this.state.params;
        params = paramsToJSON(params);
        console.log(this.state.params);
        console.log(params);
       axios({
         url:ROOT_URL + '/invoice/download'
         +jsonToParam1((params), '?'),
         method: 'GET',
         responseType: 'blob', 
         headers: {'Authorization': "Bearer " + token}
       
       }).then(response =>{ 
       const url = window.URL.createObjectURL(new Blob([response.data]));
       const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Invoices.csv'); 
      document.body.appendChild(link);
      link.click();
      params = jsonToParam(params);
      this.setState({
          params: params, flag: true
      });
   
     } ) }
   
    render() {
        const { getInvoiceData } = this.props;
        let todayDate = new Date();
        let dateForMaxStart = todayDate.toISOString().split('T')[0];
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        
        let params = this.state.params;
        params = paramsToJSON(params);
        return (
            <div className ="Dashboard">
                <nav className="Filters navbar">
                <div className="clearAllWrapper" >
                    <span className="navbar-brand nav-head">Invoices</span>
                   
                    <ul className="navbar-nav flexRowForFilters" >
                    <li className="nav-item">
                  
                        <Dropdown clearable ref="vendorId" onChange={(e, value) => this.handleClick(e, value)} placeholder='Select Supplier' search fluid selection options={this.props.vendorNamesList} />
                        
                     
                      </li>
                      <li className="nav-item">
                   
                        <Dropdown clearable ref="branch" onChange={(e, value) => this.handleClickBranch(e, value)} placeholder='Select Branch' search fluid selection options= {this.props.BranchNameList} />
                     
                      </li>
                      </ul>
                        <div className="tableFilter inputFilters">
                        <ul className="navbar-nav flexRowForFilters" >
                    <li className="nav-item">
                        <input  type="date" ref="fromDate" style ={{ height :'38px' }} onChange={(e)=>{console.log(e);this.handleStartDataChange(e)}} className="form-control" 
                       placeholder="From Date"></input>
                    </li>
                    <li className="nav-item">
                     <input type="date" ref="toDate" style ={{ height :'38px' }} onChange={(e)=>{console.log(e);this.handleEndDataChange(e)}} className="form-control" placeholder="To Date"></input>
                   </li>
                   <li className="nav-item">
                    <input  type="text" ref="poNumber" style ={{ height :'38px' }} name="poNumber" onChange={(e)=>{console.log(e);this.handlePurchaseOrderChange(e)}} className="form-control" placeholder="Search PO"></input>
                   </li>
                   <li className="nav-item">
                     <input  type="text" ref="invoiceNo" style ={{ height :'38px' }} onChange={(e)=>{console.log(e);this.handleInvoiceChange(e)}} className="form-control" placeholder="Search Invoices"></input>
                    </li>
                     <li className="nav-item">
                     <button className="btn btn-primary" style ={{ height :'38px' }} onClick={(e)=>{console.log(e);this.handleSearch(e)}}>Search</button>
                     </li>
                     <li className="nav-item">
                     <button className="btn btn-primary" style ={{ height :'38px',float:"right"}} onClick={this.getInvoiceDefaultData} >Reset</button>
                     </li>
                     <li className="nav-item">
                     <button className="btn btn-primary"  
                        style={{ height: '38px', marginBottom: '7px' }} 
                         onClick={e=>this.FileDownload1(e)} >Export</button>
                     </li>
                     </ul>
                   </div>
                       
                  
                {/* <ExcelFile element={<button className="btn btn-primary" style ={{ height :'38px' }} s>Export</button>}>
                <ExcelSheet data={getInvoiceData} name="Invoices">
                <ExcelColumn label="SUPPLIER NAME" value="vendorName"/>
                    <ExcelColumn label="INVOICE NO" value="invoiceNo"/>
                    <ExcelColumn label="PO NO" value="poNo"/>
                    <ExcelColumn label="INVOICE DATE" value="invoiceDate"/>
                    <ExcelColumn label="PRODUCT" value="productDesc"/>
                    <ExcelColumn label="QUANTITY" value="quantity"/>
                    <ExcelColumn label="PRICE/UNIT" value="pricePerUnit"/>
                    <ExcelColumn label="AMOUNT" value="totalAmount"/>
                </ExcelSheet>
            </ExcelFile> */}
            </div>
            
                </nav>
                {this.state.isLoading ? matLoader() : <div>
                
                <div className="row" style={{ paddingBottom: "12px", paddingTop: "", marginLeft: "", marginTop: "" }}>
                    <div style={{ marginTop:"10px" }} className="col-12"> 
                 
                        <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        <div className="card-header">Invoices</div>
                        <div className="card-body" style={{ maxHeight: "400" }}>
                        
                        <BootstrapTable height='400' data={this.props.getInvoiceData} striped hover version="4">
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } width="220px" dataSort={ true } isKey dataField='vendorName'>Supplier Name</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } dataSort={ true } dataField='invoiceNo'>Invoice NO</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } dataSort={ true } dataField='poNo'>PO NO</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } dataSort={ true } dataFormat={this.showDate} dataField='invoiceDate'>Invoice Date</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } width="210px" dataSort={ true } dataField='productDesc'>Product</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } dataSort={ true } dataField='quantity'>Quantity</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } dataFormat={PriceFormatter2} dataSort={ true } dataField='pricePerUnit'>Price/Unit</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } dataFormat={PriceFormatter2} dataSort={ true } dataField='totalAmount'>Amount</TableHeaderColumn>
                        </BootstrapTable>
                        </div>
                        </div></div>
                    </div>
                </div>
            </div>}
            </div>
        )
    }
}
// //Invoices.unshift('');
    // if (!_isEmpty(Invoices)) {
    //     Invoices.map((data, index) => {
    //       // if (index < excludeAfterIndex) {
    //       //;
    //       id1.push(_get('id'));
    //       vendorid1.push(_get(data, 'vendorId', ''));
    //       // }
    //     })
    //   }
function mapStateToProps(state) {
//     ;
//     let Invoicelist=[];

//     let id1=[];
//     let vendorid1=[];
//     let getInvoiceData= _get(state, 'member.getInvoiceData', []);
//     let Invoices=[getInvoiceData.data];
//     console.log(Invoices);
//     console.log(getInvoiceData.data);
//    // Invoices.push(getInvoiceData.data);

//     Invoices.map(( data, index )=>{
//         let InvoiceDataObj = {
//             id: index.id,
//             vendorId:index,
//             invoiceNo:Invoices.invoiceNo,
//             poNo : Invoices.poNo,
//             invoiceDate: Invoices.invoiceDate,
//             productId: Invoices.productId,
//             productDesc: Invoices.productDesc,
//             quantity: Invoices.quantity,
//             pricePerUnit: Invoices.pricePerUnit,
//             totalAmount:Invoices.totalAmount,
//         }
//         Invoicelist.push(InvoiceDataObj)
//     })
    let vendorNames = [];
    let vendorNameprops = _get(state, 'member.getTerminatedVPNamesForMember', []);
    vendorNameprops && vendorNameprops.map(( vname, index )=>{
        let vendorNameObj = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId
        }
        vendorNames.push(vendorNameObj)
    })

    let BranchNames = [];
    let BranchNameprops = _get(state, 'member.getMemberInvoicesBranchData', []);
    BranchNameprops && BranchNameprops.map(( vname, index )=>{
        let BranchNameObj = {
            key: index,
            text: vname.memberName,
            value: vname.memberId
        }
        BranchNames.push(BranchNameObj)
    })

    return {
        vendorNamesList: vendorNames,
        BranchNameList: BranchNames,
       // Invoicelist:Invoicelist,
        getInvoiceData: _get(state, 'member.getInvoiceData', []),
        isFetching: _get(state, 'member.isFetching', true),
        memberIdForCorporate: _get(sessionStorage, 'imark-memberId', ''),
        buyingGroupId: _get(sessionStorage, 'imark-buyingGroupId', ''),
        tabTracking: _get(state, 'corporate.tabTracking', []),
    }

}
//;
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInvoiceDataAPI: getInvoiceData,
       // getMemberVendorNamesAPI: getMemberVendorNames
        getTerminatedVPNamesForMemberAPI :getTerminatedVPNamesForMember,
        getMemberInvoicesBranchDataAPI:getMemberInvoicesBranchData,
        tabTrackingAPI:tabTracking,
    },
        dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceData);